<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right">
      <div class="toolbar-filter-bar">
        <el-form :inline="true" :model="filters" class="toolbar-filter-form">
          <div class="toolbar-filter-fields">
            <el-form-item label="发布者">
              <el-select v-model="filters.publisherType" clearable placeholder="全部" class="toolbar-field-w-md">
                <el-option label="教师" :value="1"></el-option>
                <el-option label="家长" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="审核">
              <el-select v-model="filters.auditStatus" clearable placeholder="全部" class="toolbar-field-w-md">
                <el-option label="待审" :value="0"></el-option>
                <el-option label="通过" :value="1"></el-option>
                <el-option label="拒绝" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="删除">
              <el-select v-model="filters.isDeleted" clearable placeholder="全部" class="toolbar-field-w-md">
                <el-option label="正常" :value="false"></el-option>
                <el-option label="已删" :value="true"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="filters.keyword" clearable placeholder="内容/发布者" class="toolbar-field-w-lg"></el-input>
            </el-form-item>
            <el-form-item label="日期">
              <el-date-picker v-model="filters.dateRange" type="daterange" value-format="yyyy-MM-dd"
                start-placeholder="开始" end-placeholder="结束" class="toolbar-field-w-daterange"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
            </el-form-item>
          </div>
          <div class="toolbar-filter-actions">
            <el-button v-for="item in actionButtonList" :key="item.id || item.Func"
              size="small"
              :type="resolveActionButton(item).type"
              :plain="resolveActionButton(item).plain"
              :icon="resolveActionButton(item).icon"
              :loading="!!item.loading" @click="btnClick(item)">{{ item.name }}</el-button>
          </div>
        </el-form>
      </div>

            <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
            <div class="tbl-scroll-host">
            <el-table :data="rows" v-loading="listLoading" stripe style="width: 100%;" height="100%"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="45" align="center"></el-table-column>
        <el-table-column prop="departmentName" label="班级" min-width="100" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.departmentName || scope.row.DepartmentName }}</template>
        </el-table-column>
        <el-table-column label="发布者" min-width="90" align="center">
          <template slot-scope="scope">
            {{ publisherLabel(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="类型" width="70" align="center">
          <template slot-scope="scope">{{ contentTypeText(scope.row.contentType != null ? scope.row.contentType : scope.row.ContentType) }}</template>
        </el-table-column>
        <el-table-column label="来源" width="100" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ refSourceLabel(scope.row) }}</template>
        </el-table-column>
        <el-table-column label="内容摘要" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">{{ truncateText(scope.row.textContent || scope.row.TextContent, 80) }}</template>
        </el-table-column>
        <el-table-column label="媒体" width="132" align="center">
          <template slot-scope="scope">
            <div v-if="rowMediaList(scope.row).length" class="table-media-cell" @click="openMediaPreview(scope.row)">
              <template v-for="(m, idx) in rowMediaList(scope.row).slice(0, 3)">
                <oss-el-image
                  v-if="isImageMedia(m)"
                  :key="'img-' + idx"
                  class="table-media-thumb"
                  :src="m.url || m.Url"
                  fit="cover"
                  @click.native.stop="openMediaPreview(scope.row)"
                />
                <div
                  v-else-if="isVideoMedia(m)"
                  :key="'video-' + idx"
                  class="table-media-video"
                  @click.stop="openMediaPreview(scope.row)"
                >
                  <oss-el-image
                    v-if="videoCoverRaw(m)"
                    class="table-media-thumb"
                    :src="videoCoverRaw(m)"
                    fit="cover"
                  />
                  <video
                    v-else-if="!isOssVideoUrl(m.url || m.Url)"
                    class="table-media-thumb"
                    :src="mediaUrl(m.url || m.Url) + '#t=0.5'"
                    muted
                    preload="metadata"
                  ></video>
                  <div v-else class="table-media-video-oss">
                    <i class="el-icon-video-camera"></i>
                  </div>
                  <span class="table-media-video-badge"><i class="el-icon-video-play"></i></span>
                </div>
              </template>
              <span v-if="rowMediaList(scope.row).length > 3" class="table-media-more">
                +{{ rowMediaList(scope.row).length - 3 }}
              </span>
            </div>
            <span v-else class="muted-text">—</span>
          </template>
        </el-table-column>
        <el-table-column label="点赞" width="58" align="center">
          <template slot-scope="scope">
            <el-button type="text" class="link-btn" @click="openInteractionDetail(scope.row, 'like')">
              {{ likeCount(scope.row) }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="评论" width="64" align="center">
          <template slot-scope="scope">
            <el-button type="text" class="link-btn" @click="openInteractionDetail(scope.row, 'comment')">
              {{ commentCount(scope.row) }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="收藏" width="58" align="center">
          <template slot-scope="scope">
            <el-button type="text" class="link-btn" @click="openInteractionDetail(scope.row, 'favorite')">
              {{ favoriteCount(scope.row) }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="审核" width="80" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="auditTagType(scope.row.auditStatus != null ? scope.row.auditStatus : scope.row.AuditStatus)">
              {{ auditStatusText(scope.row.auditStatus != null ? scope.row.auditStatus : scope.row.AuditStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="发布时间" width="155" align="center">
          <template slot-scope="scope">{{ formatDateTime(scope.row.createTime || scope.row.CreateTime) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="70" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="(scope.row.isDeleted || scope.row.IsDeleted) ? 'info' : 'success'">
              {{ (scope.row.isDeleted || scope.row.IsDeleted) ? "已删" : "正常" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center" fixed="right">
          <template slot-scope="scope">
            <div class="table-op-pair">
              <el-button type="text" size="small" class="table-op-link" @click="openInteractionDetail(scope.row, 'comment')">评论</el-button>
              <template v-if="scope.row.isDeleted || scope.row.IsDeleted">
                <el-button type="text" size="small" class="table-op-link" @click="restorePostRow(scope.row)">恢复</el-button>
              </template>
              <template v-else>
                <el-button v-if="canAudit(scope.row)" type="text" size="small" class="table-op-link" @click="openAudit(scope.row, true)">通过</el-button>
                <el-button v-if="canAudit(scope.row)" type="text" size="small" class="table-op-link" @click="openAudit(scope.row, false)">拒绝</el-button>
                <el-button type="text" size="small" class="table-op-link table-op-link--danger" @click="deletePostRow(scope.row)">删帖</el-button>
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>
            </div>

      <div class="pagination-container">
        <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange"
          :current-page="page" :page-size="pageSize" :total="total"></el-pagination>
      </div>

      <el-dialog
        :title="mediaDialogTitle"
        :visible.sync="mediaDialogVisible"
        width="760px"
        top="8vh"
        custom-class="media-preview-dialog"
        :append-to-body="true"
        :close-on-click-modal="false"
        @closed="onMediaDialogClosed"
      >
        <div v-if="!previewMediaList.length" class="media-preview-empty">暂无媒体</div>
        <div v-else class="media-preview-list" v-loading="mediaVideoLoading">
          <div v-for="(m, idx) in previewMediaList" :key="idx" class="media-preview-item">
            <div class="media-preview-label">{{ mediaTypeLabel(m) }} {{ idx + 1 }}</div>
            <div v-if="isImageMedia(m)" class="media-preview-image-box">
              <oss-el-image
                class="media-preview-image"
                :src="m.url || m.Url"
                fit="contain"
                :preview-src-list="previewImagePathList"
              />
            </div>
            <div v-else-if="isVideoMedia(m)" class="media-preview-video-wrap">
              <video
                v-if="previewVideoPlaySrcMap[idx]"
                class="media-preview-video"
                :src="previewVideoPlaySrcMap[idx]"
                :poster="videoCoverUrl(m)"
                controls
                preload="metadata"
              ></video>
              <div v-else class="media-preview-empty">视频加载中…</div>
            </div>
            <div v-else class="media-preview-empty">无法识别的媒体格式</div>
          </div>
        </div>
        <div slot="footer">
          <el-button @click="mediaDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <el-dialog title="拒绝原因" :visible.sync="rejectVisible" width="420px" :close-on-click-modal="false">
        <el-input v-model="rejectReason" type="textarea" :rows="3" maxlength="200" show-word-limit placeholder="请输入拒绝原因"></el-input>
        <div slot="footer">
          <el-button @click="rejectVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmReject" :loading="auditLoading">确定</el-button>
        </div>
      </el-dialog>

      <el-dialog
        :title="interactionDialogTitle"
        :visible.sync="interactionDialogVisible"
        width="860px"
        top="8vh"
        custom-class="interaction-detail-dialog"
        :append-to-body="true"
        :close-on-click-modal="false"
        @closed="onInteractionDialogClosed"
      >
        <div v-if="detailPost" class="interaction-dialog-body">
          <div class="post-brief">
            <div class="post-brief-row">
              <span class="label">班级</span>
              <span>{{ detailPost.departmentName || detailPost.DepartmentName }}</span>
            </div>
            <div class="post-brief-row">
              <span class="label">发布者</span>
              <span>{{ publisherLabel(detailPost) }}</span>
            </div>
            <div class="post-brief-row">
              <span class="label">内容</span>
              <span class="post-brief-content">{{ detailPost.textContent || detailPost.TextContent || "（无文字）" }}</span>
            </div>
            <div v-if="detailMediaList.length" class="post-media">
              <template v-for="(m, idx) in detailMediaList">
                <oss-el-image
                  v-if="isImageMedia(m)"
                  :key="'brief-img-' + idx"
                  :src="m.url || m.Url"
                  fit="cover"
                  class="media-thumb"
                  :preview-src-list="detailImagePathList"
                />
                <div
                  v-else-if="isVideoMedia(m)"
                  :key="'brief-video-' + idx"
                  class="media-video-thumb"
                  @click="openMediaPreview(detailPost)"
                >
                  <oss-el-image
                    v-if="videoCoverRaw(m)"
                    :src="videoCoverRaw(m)"
                    fit="cover"
                    class="media-thumb"
                  />
                  <video
                    v-else-if="!isOssVideoUrl(m.url || m.Url)"
                    class="media-thumb"
                    :src="mediaUrl(m.url || m.Url) + '#t=0.5'"
                    preload="metadata"
                    muted
                  ></video>
                  <div v-else class="media-thumb media-video-placeholder">
                    <i class="el-icon-video-camera"></i>
                  </div>
                  <span class="media-video-badge"><i class="el-icon-video-play"></i></span>
                </div>
              </template>
            </div>
          </div>

          <el-tabs v-model="interactionTab" @tab-click="onInteractionTabChange">
            <el-tab-pane :label="'评论（' + commentTotal + '）'" name="comment">
              <div class="interaction-tab-toolbar">
                <el-checkbox v-model="commentIncludeDeleted" @change="onCommentFilterChange">含已删</el-checkbox>
              </div>
              <el-table :data="commentRows" size="small" stripe class="interaction-table" max-height="360" v-loading="commentLoading">
                <el-table-column label="评论Id" width="88" align="center">
                  <template slot-scope="scope">{{ rowId(scope.row) }}</template>
                </el-table-column>
                <el-table-column label="评论者" width="120" align="center" show-overflow-tooltip>
                  <template slot-scope="scope">{{ commenterLabel(scope.row) }}</template>
                </el-table-column>
                <el-table-column label="内容" min-width="160" show-overflow-tooltip>
                  <template slot-scope="scope">{{ scope.row.content || scope.row.Content }}</template>
                </el-table-column>
                <el-table-column label="父评论" width="76" align="center">
                  <template slot-scope="scope">{{ parentCommentId(scope.row) || "—" }}</template>
                </el-table-column>
                <el-table-column label="时间" width="150" align="center">
                  <template slot-scope="scope">{{ formatDateTime(scope.row.createTime || scope.row.CreateTime) }}</template>
                </el-table-column>
                <el-table-column label="状态" width="72" align="center">
                  <template slot-scope="scope">
                    <el-tag size="mini" :type="isCommentDeleted(scope.row) ? 'info' : 'success'">
                      {{ isCommentDeleted(scope.row) ? "已删" : "正常" }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                  <template slot-scope="scope">
                    <el-button v-if="!isCommentDeleted(scope.row)" type="text" size="small" class="table-op-link table-op-link--danger" @click="handleDeleteComment(scope.row)">删评</el-button>
                    <span v-else class="muted-text">—</span>
                  </template>
                </el-table-column>
              </el-table>
              <div class="interaction-pagination">
                <el-pagination layout="total, prev, pager, next" small
                  :current-page="commentPage" :page-size="commentPageSize" :total="commentTotal"
                  @current-change="handleCommentPageChange"></el-pagination>
              </div>
            </el-tab-pane>

            <el-tab-pane :label="'点赞（' + likeTotal + '）'" name="like">
              <el-table :data="likeRows" size="small" stripe class="interaction-table" max-height="400" v-loading="likeLoading">
                <el-table-column label="记录Id" width="88" align="center">
                  <template slot-scope="scope">{{ rowId(scope.row) }}</template>
                </el-table-column>
                <el-table-column label="点赞者" min-width="140" align="center" show-overflow-tooltip>
                  <template slot-scope="scope">{{ formatActorLabel(scope.row) }}</template>
                </el-table-column>
                <el-table-column label="操作者Id" width="100" align="center">
                  <template slot-scope="scope">{{ scope.row.actorId != null ? scope.row.actorId : scope.row.ActorId }}</template>
                </el-table-column>
                <el-table-column label="时间" width="160" align="center">
                  <template slot-scope="scope">{{ formatDateTime(scope.row.createTime || scope.row.CreateTime) }}</template>
                </el-table-column>
              </el-table>
              <div class="interaction-pagination">
                <el-pagination layout="total, prev, pager, next" small
                  :current-page="likePage" :page-size="likePageSize" :total="likeTotal"
                  @current-change="handleLikePageChange"></el-pagination>
              </div>
            </el-tab-pane>

            <el-tab-pane :label="'收藏（' + favoriteTotal + '）'" name="favorite">
              <el-table :data="favoriteRows" size="small" stripe class="interaction-table" max-height="400" v-loading="favoriteLoading">
                <el-table-column label="记录Id" width="88" align="center">
                  <template slot-scope="scope">{{ rowId(scope.row) }}</template>
                </el-table-column>
                <el-table-column label="收藏者" min-width="140" align="center" show-overflow-tooltip>
                  <template slot-scope="scope">{{ formatActorLabel(scope.row) }}</template>
                </el-table-column>
                <el-table-column label="操作者Id" width="100" align="center">
                  <template slot-scope="scope">{{ scope.row.actorId != null ? scope.row.actorId : scope.row.ActorId }}</template>
                </el-table-column>
                <el-table-column label="时间" width="160" align="center">
                  <template slot-scope="scope">{{ formatDateTime(scope.row.createTime || scope.row.CreateTime) }}</template>
                </el-table-column>
              </el-table>
              <div class="interaction-pagination">
                <el-pagination layout="total, prev, pager, next" small
                  :current-page="favoritePage" :page-size="favoritePageSize" :total="favoriteTotal"
                  @current-change="handleFavoritePageChange"></el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div slot="footer">
          <el-button @click="interactionDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import DepartmentPane from "../../components/DepartmentPane";
import { getButtonList } from "../../promissionRouter";
import { resolveMediaUrl, resolvePlayableMediaUrl, isAliyunOssHttpsUrl } from "@/utils/mediaUrl";
import { getUploadSchoolId } from "@/utils/ossMediaUpload";
import {
  getClassCirclePostPage,
  getClassCircleCommentPage,
  getClassCircleLikePage,
  getClassCircleFavoritePage,
  auditClassCirclePost,
  deleteClassCirclePost,
  restoreClassCirclePost,
  deleteClassCircleComment,
  exportClassCirclePosts,
  downloadBlobExcel,
  onClassCircleDeptChange,
  clearClassCircleListTable,
  resolveClassCircleActionButton,
  pickSingleRow,
  pickMultiRows,
  contentTypeText,
  auditStatusText,
  formatDateTime,
  truncateText,
  countMediaItems,
  parseMediaList,
  isImageMedia,
  isVideoMedia,
  mediaTypeLabel,
  commenterTypeLabel,
  actorLabel as formatActorLabel,
  refSourceLabel
} from "@/api/classCircle";

export default {
  components: { DepartmentPane },
  data() {
    return {
      filters: {
        publisherType: null,
        auditStatus: null,
        isDeleted: null,
        keyword: "",
        dateRange: null
      },
      actionButtonList: [],
      multipleSelection: [],
      rows: [],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      DepartmentId: 0,
      rejectVisible: false,
      rejectReason: "",
      auditLoading: false,
      auditTarget: null,
      interactionDialogVisible: false,
      interactionDialogTitle: "互动明细",
      interactionTab: "comment",
      commentLoading: false,
      likeLoading: false,
      favoriteLoading: false,
      commentIncludeDeleted: true,
      detailPost: null,
      commentRows: [],
      commentPage: 1,
      commentPageSize: 10,
      commentTotal: 0,
      likeRows: [],
      likePage: 1,
      likePageSize: 10,
      likeTotal: 0,
      favoriteRows: [],
      favoritePage: 1,
      favoritePageSize: 10,
      favoriteTotal: 0,
      mediaDialogVisible: false,
      mediaDialogTitle: "媒体预览",
      mediaPreviewRow: null,
      mediaVideoLoading: false,
      previewVideoPlaySrcMap: {}
    };
  },
  computed: {
    detailMediaList() {
      if (!this.detailPost) return [];
      return parseMediaList(this.detailPost.mediaJson || this.detailPost.MediaJson);
    },
    detailImagePathList() {
      return this.detailMediaList
        .filter(isImageMedia)
        .map(m => m.url || m.Url);
    },
    previewMediaList() {
      if (!this.mediaPreviewRow) return [];
      return parseMediaList(this.mediaPreviewRow.mediaJson || this.mediaPreviewRow.MediaJson);
    },
    previewImagePathList() {
      return this.previewMediaList
        .filter(isImageMedia)
        .map(m => m.url || m.Url);
    }
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    const buttonList = getButtonList(this.$route.path, routers);
    this.actionButtonList = buttonList.filter(b => b.Func !== "handleQuery");
  },
  methods: {
    btnClick(item) {
      if (item.Func && typeof this[item.Func] === "function") {
        this[item.Func](item);
      }
    },
    resolveActionButton(item) {
      return resolveClassCircleActionButton(item);
    },
    contentTypeText,
    auditStatusText,
    formatDateTime,
    truncateText,
    countMediaItems,
    isImageMedia,
    isVideoMedia,
    mediaTypeLabel,
    commenterTypeLabel,
    refSourceLabel,
    resolveMediaUrl,
    isOssVideoUrl(url) {
      return isAliyunOssHttpsUrl(url);
    },
    mediaUrl(url) {
      return resolveMediaUrl(url);
    },
    rowMediaList(row) {
      return parseMediaList(row.mediaJson || row.MediaJson);
    },
    videoCoverRaw(item) {
      const cover = item && (item.cover || item.Cover);
      return cover ? String(cover).trim() : "";
    },
    videoCoverUrl(item) {
      const cover = this.videoCoverRaw(item);
      return cover ? this.mediaUrl(cover) : "";
    },
    async refreshPreviewMediaPlaySrc() {
      this.previewVideoPlaySrcMap = {};
      const list = this.previewMediaList;
      if (!list.length) return;
      const needLoad = list.some(m => isVideoMedia(m));
      if (!needLoad) return;

      this.mediaVideoLoading = true;
      try {
        await Promise.all(list.map(async (m, idx) => {
          const raw = m.url || m.Url;
          const path = String(raw || "").trim();
          if (!path) return;
          const schoolId = getUploadSchoolId(this);
          if (!isVideoMedia(m)) return;
          try {
            const url = await resolvePlayableMediaUrl(path, schoolId);
            this.$set(this.previewVideoPlaySrcMap, idx, url);
          } catch (e) {
            if (isAliyunOssHttpsUrl(path)) {
              this.$message.error((e && e.message) || "无法播放 OSS 视频");
              return;
            }
            this.$set(this.previewVideoPlaySrcMap, idx, resolveMediaUrl(path));
          }
        }));
      } finally {
        this.mediaVideoLoading = false;
      }
    },
    onMediaDialogClosed() {
      this.mediaPreviewRow = null;
      this.previewVideoPlaySrcMap = {};
      this.mediaVideoLoading = false;
    },
    async openMediaPreview(row) {
      if (!this.rowMediaList(row).length) return;
      const postId = row.id != null ? row.id : row.Id;
      this.mediaPreviewRow = row;
      this.mediaDialogTitle = "媒体预览 · 帖子 " + postId;
      this.mediaDialogVisible = true;
      await this.refreshPreviewMediaPlaySrc();
    },
    publisherLabel(row) {
      const type = row.publisherType != null ? row.publisherType : row.PublisherType;
      const name = row.publisherName || row.PublisherName || "";
      return (type === 1 ? "教师" : "家长") + (name ? "：" + name : "");
    },
    likeCount(row) {
      const v = row.likeCount != null ? row.likeCount : row.LikeCount;
      return v != null ? v : 0;
    },
    commentCount(row) {
      const v = row.commentCount != null ? row.commentCount : row.CommentCount;
      return v != null ? v : 0;
    },
    favoriteCount(row) {
      const v = row.favoriteCount != null ? row.favoriteCount : row.FavoriteCount;
      return v != null ? v : 0;
    },
    auditTagType(status) {
      if (status === 0) return "warning";
      if (status === 2) return "danger";
      return "success";
    },
    canAudit(row) {
      const type = row.publisherType != null ? row.publisherType : row.PublisherType;
      const status = row.auditStatus != null ? row.auditStatus : row.AuditStatus;
      return type === 2 && status === 0;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val || [];
    },
    handleAdd() {
      this.$message.info("帖子由教师/家长在 H5 发布，后台不支持新建");
    },
    handleEdit() {
      const row = pickSingleRow(this, "请选择一行帖子");
      if (!row) return;
      this.openInteractionDetail(row, "comment");
    },
    handleDel() {
      const rows = pickMultiRows(this, "请选择要删除的帖子");
      if (!rows) return;
      const activeRows = rows.filter(r => !(r.isDeleted || r.IsDeleted));
      if (!activeRows.length) {
        this.$message.warning("所选帖子均已删除");
        return;
      }
      this.$confirm("确认删除选中的 " + activeRows.length + " 条帖子？", "删帖", { type: "warning" }).then(async () => {
        for (const row of activeRows) {
          const postId = row.id != null ? row.id : row.Id;
          const res = await deleteClassCirclePost(postId);
          if (!res.data.success) {
            this.$message.error(res.data.msg || "删除失败");
            return;
          }
        }
        this.$message.success("删除成功");
        this.getList();
      }).catch(() => {});
    },
    treeNodeClick(data) {
      onClassCircleDeptChange(this, data.value);
      this.handleQuery();
    },
    buildQuery() {
      const q = {
        departmentId: this.DepartmentId,
        pageIndex: this.page,
        pageSize: this.pageSize
      };
      if (this.filters.publisherType != null && this.filters.publisherType !== "") {
        q.publisherType = this.filters.publisherType;
      }
      if (this.filters.auditStatus != null && this.filters.auditStatus !== "") {
        q.auditStatus = this.filters.auditStatus;
      }
      if (this.filters.isDeleted != null && this.filters.isDeleted !== "") {
        q.isDeleted = this.filters.isDeleted;
      }
      if (this.filters.keyword) q.keyword = String(this.filters.keyword).trim();
      if (this.filters.dateRange && this.filters.dateRange.length === 2) {
        q.startDate = this.filters.dateRange[0];
        q.endDate = this.filters.dateRange[1];
      }
      return q;
    },
    handleQuery() {
      this.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    async getList() {
      if (!this.DepartmentId) {
        clearClassCircleListTable(this);
        return;
      }
      this.listLoading = true;
      try {
        const res = await getClassCirclePostPage(this.buildQuery());
        if (res.data.success) {
          this.rows = res.data.response.data || [];
          this.total = res.data.response.dataCount || 0;
        } else {
          clearClassCircleListTable(this);
          this.$message.error(res.data.msg || "查询失败");
        }
      } finally {
        this.listLoading = false;
      }
    },
    openAudit(row, approve) {
      if (approve) {
        this.$confirm("确认通过该帖子？", "审核", { type: "warning" }).then(() => {
          this.submitAudit(row, true, "");
        }).catch(() => {});
        return;
      }
      this.auditTarget = row;
      this.rejectReason = "";
      this.rejectVisible = true;
    },
    async confirmReject() {
      if (!this.rejectReason.trim()) {
        this.$message.warning("请填写拒绝原因");
        return;
      }
      await this.submitAudit(this.auditTarget, false, this.rejectReason.trim());
      this.rejectVisible = false;
    },
    async submitAudit(row, approve, rejectReason) {
      const postId = row.id != null ? row.id : row.Id;
      this.auditLoading = true;
      try {
        const res = await auditClassCirclePost({ postId, approve, rejectReason });
        if (res.data.success) {
          this.$message.success(res.data.msg || "操作成功");
          this.getList();
        } else {
          this.$message.error(res.data.msg || "操作失败");
        }
      } finally {
        this.auditLoading = false;
      }
    },
    deletePostRow(row) {
      const postId = row.id != null ? row.id : row.Id;
      this.$confirm("确认删除该帖子？删除后前台不再展示，后台可恢复。", "删帖", { type: "warning" }).then(async () => {
        const res = await deleteClassCirclePost(postId);
        if (res.data.success) {
          this.$message.success(res.data.msg || "删除成功");
          this.getList();
        } else {
          this.$message.error(res.data.msg || "删除失败");
        }
      }).catch(() => {});
    },
    restorePostRow(row) {
      const postId = row.id != null ? row.id : row.Id;
      this.$confirm("确认恢复该帖子？恢复后将按原审核状态重新对外展示。", "恢复帖子", { type: "warning" }).then(async () => {
        const res = await restoreClassCirclePost(postId);
        if (res.data.success) {
          this.$message.success(res.data.msg || "恢复成功");
          this.getList();
        } else {
          this.$message.error(res.data.msg || "恢复失败");
        }
      }).catch(() => {});
    },
    formatActorLabel,
    openInteractionDetail(row, tab) {
      this.detailPost = row;
      const postId = row.id != null ? row.id : row.Id;
      this.interactionDialogTitle = "互动明细 · 帖子 " + postId;
      this.interactionTab = tab || "comment";
      this.commentPage = 1;
      this.likePage = 1;
      this.favoritePage = 1;
      this.commentTotal = this.commentCount(row);
      this.likeTotal = this.likeCount(row);
      this.favoriteTotal = this.favoriteCount(row);
      this.interactionDialogVisible = true;
      this.loadInteractionTabData();
    },
    onInteractionDialogClosed() {
      this.detailPost = null;
      this.interactionTab = "comment";
      this.commentRows = [];
      this.commentTotal = 0;
      this.likeRows = [];
      this.likeTotal = 0;
      this.favoriteRows = [];
      this.favoriteTotal = 0;
    },
    onInteractionTabChange() {
      this.loadInteractionTabData();
    },
    loadInteractionTabData() {
      if (this.interactionTab === "comment") this.loadPostComments();
      else if (this.interactionTab === "like") this.loadPostLikes();
      else if (this.interactionTab === "favorite") this.loadPostFavorites();
    },
    onCommentFilterChange() {
      this.commentPage = 1;
      this.loadPostComments();
    },
    handleCommentPageChange(val) {
      this.commentPage = val;
      this.loadPostComments();
    },
    rowId(row) {
      return row.id != null ? row.id : row.Id;
    },
    commenterLabel(row) {
      const type = row.commenterType != null ? row.commenterType : row.CommenterType;
      const name = row.commenterName || row.CommenterName || "";
      return commenterTypeLabel(type) + (name ? "：" + name : "");
    },
    parentCommentId(row) {
      const pid = row.parentCommentId != null ? row.parentCommentId : row.ParentCommentId;
      return pid && pid > 0 ? pid : "";
    },
    isCommentDeleted(row) {
      return !!(row.isDeleted != null ? row.isDeleted : row.IsDeleted);
    },
    buildCommentQuery() {
      const postId = this.detailPost.id != null ? this.detailPost.id : this.detailPost.Id;
      const q = {
        postId,
        pageIndex: this.commentPage,
        pageSize: this.commentPageSize
      };
      if (!this.commentIncludeDeleted) q.isDeleted = false;
      return q;
    },
    buildActorQuery(page, pageSize) {
      const postId = this.detailPost.id != null ? this.detailPost.id : this.detailPost.Id;
      return {
        postId,
        departmentId: this.DepartmentId || undefined,
        pageIndex: page,
        pageSize
      };
    },
    async loadPostComments() {
      if (!this.detailPost) return;
      this.commentLoading = true;
      try {
        const res = await getClassCircleCommentPage(this.buildCommentQuery());
        if (res.data.success) {
          this.commentRows = res.data.response.data || [];
          this.commentTotal = res.data.response.dataCount || 0;
        } else {
          this.commentRows = [];
          this.commentTotal = 0;
          this.$message.error(res.data.msg || "加载评论失败");
        }
      } finally {
        this.commentLoading = false;
      }
    },
    async loadPostLikes() {
      if (!this.detailPost) return;
      this.likeLoading = true;
      try {
        const res = await getClassCircleLikePage(this.buildActorQuery(this.likePage, this.likePageSize));
        if (res.data.success) {
          this.likeRows = res.data.response.data || [];
          this.likeTotal = res.data.response.dataCount || 0;
        } else {
          this.likeRows = [];
          this.likeTotal = 0;
          this.$message.error(res.data.msg || "加载点赞失败");
        }
      } finally {
        this.likeLoading = false;
      }
    },
    async loadPostFavorites() {
      if (!this.detailPost) return;
      this.favoriteLoading = true;
      try {
        const res = await getClassCircleFavoritePage(this.buildActorQuery(this.favoritePage, this.favoritePageSize));
        if (res.data.success) {
          this.favoriteRows = res.data.response.data || [];
          this.favoriteTotal = res.data.response.dataCount || 0;
        } else {
          this.favoriteRows = [];
          this.favoriteTotal = 0;
          this.$message.error(res.data.msg || "加载收藏失败");
        }
      } finally {
        this.favoriteLoading = false;
      }
    },
    handleLikePageChange(val) {
      this.likePage = val;
      this.loadPostLikes();
    },
    handleFavoritePageChange(val) {
      this.favoritePage = val;
      this.loadPostFavorites();
    },
    handleDeleteComment(row) {
      const commentId = this.rowId(row);
      this.$confirm("确认删除该评论？", "删评", { type: "warning" }).then(async () => {
        const res = await deleteClassCircleComment(commentId);
        if (res.data.success) {
          this.$message.success(res.data.msg || "删除成功");
          await this.loadPostComments();
          this.getList();
        } else {
          this.$message.error(res.data.msg || "删除失败");
        }
      }).catch(() => {});
    },
    async exportExcel(item) {
      if (!this.DepartmentId) {
        this.$message.warning("请先选择机构/班级");
        return;
      }
      if (item) item.loading = true;
      try {
        const q = this.buildQuery();
        q.pageIndex = 1;
        q.pageSize = 10000;
        const res = await exportClassCirclePosts(q);
        downloadBlobExcel(res, "班级圈帖子");
      } catch (e) {
        this.$message.error("导出失败");
      } finally {
        if (item) item.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.pagination-container {
  margin-top: 16px;
  overflow: hidden;
  text-align: right;
}
.muted-text {
  color: #c0c4cc;
}
.link-btn {
  padding: 0;
  font-weight: 600;
}
.interaction-dialog-body {
  min-height: 120px;
}
.interaction-tab-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}
.post-brief {
  background: #f8fafc;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 12px 14px;
  margin-bottom: 14px;
}
.post-brief-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  line-height: 1.5;
}
.post-brief-row:last-child {
  margin-bottom: 0;
}
.post-brief-row .label {
  flex-shrink: 0;
  width: 52px;
  color: #909399;
}
.post-brief-content {
  flex: 1;
  min-width: 0;
  word-break: break-word;
}
.table-media-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 4px;
  cursor: pointer;
}
.table-media-thumb {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  flex-shrink: 0;
}
.table-media-video {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 4px;
  background: #f0f2f5;
  color: #606266;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}
.table-media-video-badge {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  background: rgba(0, 0, 0, 0.35);
  pointer-events: none;
}
.table-media-video-oss {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #606266;
  font-size: 16px;
}
.media-video-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
  color: #909399;
  font-size: 22px;
}
.media-preview-video-wrap {
  min-height: 120px;
}
.table-media-more {
  font-size: 12px;
  color: #909399;
}
.post-media {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}
.media-thumb {
  width: 72px;
  height: 72px;
  border-radius: 4px;
  object-fit: cover;
  display: block;
}
.media-video-thumb {
  position: relative;
  width: 72px;
  height: 72px;
  cursor: pointer;
}
.media-video-badge {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 22px;
  background: rgba(0, 0, 0, 0.28);
  border-radius: 4px;
  pointer-events: none;
}
.media-preview-empty {
  color: #909399;
  text-align: center;
  padding: 24px 0;
}
.media-preview-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 68vh;
  overflow: auto;
}
.media-preview-item {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 10px;
  background: #fafafa;
}
.media-preview-label {
  margin-bottom: 8px;
  font-size: 12px;
  color: #909399;
}
.media-preview-image-box {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80px;
  overflow: auto;
}
.media-preview-image {
  display: inline-block;
  max-width: 100%;
  line-height: 0;
}
.media-preview-image >>> .el-image {
  width: auto !important;
  max-width: 100%;
  height: auto !important;
  overflow: visible;
}
.media-preview-image >>> .el-image__inner,
.media-preview-image >>> img {
  width: auto !important;
  max-width: 100%;
  height: auto !important;
  max-height: calc(72vh - 180px);
  object-fit: contain;
  display: block;
  margin: 0 auto;
}
.media-preview-video {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  max-height: calc(72vh - 180px);
  background: #000;
  border-radius: 4px;
}
.interaction-table {
  width: 100%;
  margin-bottom: 10px;
}
.interaction-pagination {
  text-align: right;
}
.danger-link {
  color: #f56c6c;
  padding: 0;
  font-weight: 600;
}

.danger-link >>> .el-button__icon {
  margin-right: 4px;
}
</style>
